import * as storage from "~/utils/storage";
import { DASHBOARD_STORAGE_KEYS } from "~/constants/dashboard";

export const removeLocalCredential = () => {
  storage.remove("SNAP_GEN_USER");
  storage.remove("SNAP_GEN_ACCESS_TOKEN");
  storage.remove("SNAP_GEN_TOKEN");
  storage.remove(DASHBOARD_STORAGE_KEYS.DASHBOARD_PROGRESS);
};
export const removeUserDashboardStorage = () => {
  storage.remove(DASHBOARD_STORAGE_KEYS.KEY_FEATURE);
  storage.remove(DASHBOARD_STORAGE_KEYS.KEY_FEATURE_2);
  storage.remove(DASHBOARD_STORAGE_KEYS.STYLE_SELECTION);
  storage.remove(DASHBOARD_STORAGE_KEYS.HEADSHOT_STYLE_SELECTION);
  storage.remove(DASHBOARD_STORAGE_KEYS.SURVEY_IDS);
  storage.remove(DASHBOARD_STORAGE_KEYS.JOB_ID);
  storage.remove(DASHBOARD_STORAGE_KEYS.VERIFY_RESULT);
};
